// Translations
export const T = {
  en_GB: {
    documentation: "Documentation",
    aiAgent: "Global Agent",
    clientAgent: "Client Agent",
    clientAgentEmpty: "Client agent is available when viewing a client",
    visibilityShared: "Shared with your team",
    systemAi: "Design Agent",
    scheduler: "Agent Scheduler",
    ideas: "Ideas",
    support: "Support",
  },
  nb_NO: {
    documentation: "Dokumentasjon",
    aiAgent: "Global agent",
    clientAgent: "Kundeagent",
    clientAgentEmpty: "Kundeagent er tilgjengelig når du ser på en kunde",
    visibilityShared: "Delt med teamet ditt",
    systemAi: "Designagent",
    scheduler: "Agent-planlegger",
    ideas: "Ideer",
    support: "Support",
  },
} as const;
